/**
 * Date shown as "Última atualização" on the pages.
 *
 * This used to be generated from the visitor's clock, so every page claimed to
 * be updated "this month" even when nothing had changed — a misleading
 * freshness claim. It is now a fixed value: change it whenever the page
 * content is actually reviewed or updated.
 */
export const LAST_UPDATED = 'Novembro 2026';

/**
 * Kept under the old name so the pages that call it need no changes.
 * Example: "Novembro 2026"
 */
export const getCurrentMonthYear = () => LAST_UPDATED;
